














/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Vue from 'vue'
import { mapState } from 'vuex'
import OnlineService from '@/services/OnlineService'
import JWTUtils from '@/utils/JWTUtils'

type Data = {
  companyId: string | null;
  userId: string | null;
  applicationServiceName: string | null;
  loginUrl: string | null;
};

export default Vue.extend({
  name: 'ChangeDepartmentConfirm',
  data (): Data {
    return {
      companyId: null,
      userId: null,
      applicationServiceName: null,
      loginUrl: null
    }
  },
  computed: {
    ...mapState(['serviceName'])
  },
  created () {
    const { companyId, sub: userId } = JWTUtils.getSubject(JWTUtils.get() as string)
    this.companyId = companyId
    this.userId = userId
    OnlineService.returnUrl(companyId, userId).then(data => {
      this.applicationServiceName = data.serviceName
      this.loginUrl = data.loginUrl
    })
  },
  methods: {
    changeDepartment (): void {
      this.$store.commit('isLoading', true)
      this.$store.commit('isLoadingForce', true)
      const params = {
        companyId: this.companyId as string,
        userId: this.userId as string
      }
      const jwtToken = JWTUtils.get()
      OnlineService.changeDepartment(params).then(data => {
        let toPath
        // 口座開設申込ステータスにより遷移先を変更する
        const status = data.otcAccountOpeningRequestStatus
        if (status === 'REGISTER_USER') {
          toPath = '/upload'
        } else if (status === 'UPLOAD_IMAGE_DATA') {
          toPath = '/registercoderegistration'
        } else if (status === 'REGISTER_ACCOUNT_OPENING') {
          toPath = '/agreement/contract'
        } else if (status === 'APPLIED_ACCOUNT_OPENING') {
          toPath = '/complete'
        } else {
          toPath = '/error/404'
        }
        this.$store.commit('isLoading', false)
        this.$store.commit('isLoadingForce', false)
        this.$router.push(toPath)
      })
    },
    returnApplicationService (): void {
      this.$store.dispatch('clearLogin')
      this.$store.commit('isLoading', true)
      this.$store.commit('isLoadingForce', true)
      window.location.href = this.loginUrl as string
    }
  }
})
